<ng-container *transloco="let t">
  <section class="ln-page" aria-label="Login page">

    <!-- ══════════════════════════════ LEFT PANEL ══════════════════════════════ -->

    <div class="ln-left !hidden" style="background-image: url(./assets/images/login-banner.png); background-size: cover;" aria-hidden="true"></div>
    <div class="ln-left" aria-hidden="true">
      <!-- Animated vertical stripes background -->
      <div class="ln-stripes">
        <div class="ln-stripe" *ngFor="let s of stripes; let i = index"
          [style.--delay]="(i * 0.15) + 's'"
          [style.--hue]="s.hue"
          [style.--sat]="s.sat"
          [style.--lt]="s.lt">
        </div>
      </div>

      <!-- Tablet mockup -->
      <div class="ln-mockup">
        <div class="ln-mockup__device">
          <div class="ln-mockup__screen">
            <img src="./assets/images/login-dashboard.png"
                 alt="Dashboard preview"
                 class="ln-mockup__img"
                 onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'">
            <!-- Fallback placeholder dashboard -->
            <div class="ln-mockup__placeholder" style="display:none">
              <div class="ln-mock-sidebar">
                <div class="ln-mock-logo"></div>
                <div class="ln-mock-nav">
                  <div class="ln-mock-nav__item ln-mock-nav__item--active"></div>
                  <div class="ln-mock-nav__item"></div>
                  <div class="ln-mock-nav__item"></div>
                  <div class="ln-mock-nav__item"></div>
                  <div class="ln-mock-nav__item"></div>
                </div>
              </div>
              <div class="ln-mock-content">
                <div class="ln-mock-header"></div>
                <div class="ln-mock-cards">
                  <div class="ln-mock-card"></div>
                  <div class="ln-mock-card"></div>
                  <div class="ln-mock-card"></div>
                  <div class="ln-mock-card"></div>
                </div>
                <div class="ln-mock-charts">
                  <div class="ln-mock-chart ln-mock-chart--bar">
                    <div class="ln-mock-bar" style="height:40%"></div>
                    <div class="ln-mock-bar" style="height:65%"></div>
                    <div class="ln-mock-bar" style="height:50%"></div>
                    <div class="ln-mock-bar" style="height:80%"></div>
                    <div class="ln-mock-bar" style="height:55%"></div>
                    <div class="ln-mock-bar" style="height:70%"></div>
                    <div class="ln-mock-bar" style="height:45%"></div>
                  </div>
                  <div class="ln-mock-chart ln-mock-chart--line">
                    <svg viewBox="0 0 100 50" preserveAspectRatio="none">
                      <polyline points="0,40 20,30 40,35 60,15 80,20 100,10"
                        fill="none" stroke="rgba(111,97,255,0.5)" stroke-width="2"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ══════════════════════════════ RIGHT PANEL ══════════════════════════════ -->
    <main class="ln-right" role="main">
      <div class="ln-form-wrapper" role="region" [attr.aria-label]="isForget() ? 'Forgot password form' : 'Sign in form'">

        <!-- Heading -->
        <div class="ln-heading">
          @if (isForget()) {
            <h1 class="ln-heading__title">Forgot Password</h1>
            <p class="ln-heading__subtitle">Provide your email to request a password reset. An admin will create a new password for you.</p>
          } @else {
            <h1 class="ln-heading__title">Sign in</h1>
            <p class="ln-heading__subtitle">Welcome! Please enter your details below.</p>
          }
        </div>

        <!-- Form -->
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="ln-form" autocomplete="on" novalidate>

          <!-- Email field -->
          <div class="ln-field">
            <label class="ln-field__label" for="login-email">Username/Email</label>
            <div class="ln-field__input-wrap" [class.ln-field__input-wrap--error]="loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched">
              <input
                id="login-email"
                class="ln-field__input"
                type="email"
                formControlName="username"
                autocomplete="email"
                placeholder="ex. john.d@hthai.co.th"
                aria-label="Email address">
            </div>
            @if (loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched) {
              <span class="ln-field__error">Email is required</span>
            }
          </div>

          <!-- Password field (hidden in forgot mode) -->
          @if (!isForget()) {
            <div class="ln-field">
              <label class="ln-field__label" for="login-password">Password</label>
              <div class="ln-field__input-wrap" [class.ln-field__input-wrap--error]="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
                <input
                  id="login-password"
                  class="ln-field__input"
                  [type]="hidePassword() ? 'password' : 'text'"
                  formControlName="password"
                  autocomplete="current-password"
                  placeholder="••••••••"
                  aria-label="Password">
                <button
                  type="button"
                  class="ln-field__eye"
                  (click)="togglePassword()"
                  [attr.aria-label]="hidePassword() ? 'Show password' : 'Hide password'">
                  @if (hidePassword()) {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
                      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
                      <line x1="1" y1="1" x2="23" y2="23"/>
                    </svg>
                  } @else {
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                      <circle cx="12" cy="12" r="3"/>
                    </svg>
                  }
                </button>
              </div>
              @if (loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched) {
                <span class="ln-field__error">Password is required</span>
              }
            </div>

            <!-- Remember Me + Forgot Password row -->
            <div class="ln-options-row">
              <label class="ln-remember">
                <input type="checkbox" class="ln-remember__check" id="remember-me" formControlName="rememberMe">
                <span class="ln-remember__label">Remember Me</span>
              </label>
              <button type="button" class="ln-forgot-link" (click)="navigateToForgot()">
                Forgot Password?
              </button>
            </div>
          }

          <!-- Submit button -->
          <button
            type="submit"
            class="ln-btn-submit"
            id="login-submit-btn"
            [disabled]="formLoading()"
            aria-live="polite">
            @if (formLoading()) {
              <span class="ln-btn-submit__spinner"></span>
              <span>{{ isForget() ? 'Sending...' : 'Signing in...' }}</span>
            } @else {
              <span>{{ isForget() ? 'Request New Password' : 'Sign In' }}</span>
            }
          </button>

          @if (isForget()) {
            <div class="ln-back-row">
              <button type="button" class="ln-forgot-link" (click)="navigateToLogin()">
                Back to sign in
              </button>
            </div>
          }

        </form>

      </div>
    </main>

  </section>
</ng-container>